<template>
    <div class="dycontainer-content flex fillH fillW col">
        <div class="col flex fillW">
            <el-table
                @selection-change="handleSelectionChange" ref="tableRef"
                :data="data" :height="computedHeight" v-loading="loading" :style="tableStyle" :row-class-name="rowClassName" :max-height="height">
                <el-table-column v-if="checkBox && tableHeader.length>0" type="selection" width="55" />
                <el-table-column v-for="(item, index) in tableHeader" :show-overflow-tooltip="item.noTooltip?true:false" align="center" :key="index" :prop="item.prop" :type="item.type" :width="item.width"
                    :label="item.propLabel" :formatter="item.formatter">
                    <template v-if="item.slot" v-slot="{ row }">
                        <slot :name="item.slot" :row="row">
                        </slot>
                    </template>
                </el-table-column>
                <el-table-column label="操作" v-if="$slots.operation && tableHeader.length>0" align="center" width="210"
                                 class-name="small-padding fixed-width">
                    <template #default="scope">
                        <slot name="operation" :row="scope.row" :$index="scope.$index"></slot>
                    </template>
                </el-table-column>
            </el-table>
            <div class="align fillW ">
                <Pagination v-if="total>0" :total="total" popper-class="screen-select" :page.sync="pager.pageNo" :limit.sync="pager.pageSize"
                    @pagination="getPagination" />
            </div>
        </div>
    </div>
</template>
<!-- 表单 -->
<script>

export default {
    props: {
        tableStyle: {
            type: Object,
            default: () => ({})
        },
        checkBox: {
            type: Boolean,
            default: false
        },
        // 表头
        columns: {
            type: Array,
            default: () => []
        },
        data: {
            type: Array,
            default: []
        },
        loading: {
            type: Boolean,
            default: false
        },
        total: {
            type: Number,
            default: 0
        }, // 分页总数

        height: {
            type: [String,Number],
            default: 600
        },
        isScreen:{
            type: Boolean,
            default: false
        },
        tableHeight:{
            type: [String,Number],
            default: 600
        },
        size:{
            type: Number,
            default: 10
        },
        page:{
            type: Number,
            default: 1
        },
        exportValue:{
            type: String,
            default: 'id'
        },
    },
    data() {
        return {
            pager: {
                pageNo: this.page, // 当前页面
                pageSize: this.size // 每页展示页面
            },
            tableHeader: this.columns,
            multipleSelection:[]
        }
    },
    created() {

    },
    watch: {
        columns: {
            handler(newVal) {
                this.tableHeader = newVal
            }
        },
        page: {
            handler(newVal) {
                this.pager.pageNo= newVal
            }
        },
        size: {
            handler(newVal) {
                this.pager.pageSize= newVal
            }
        },
        data: {
            handler(newVal) {
                console.log(newVal,'wodouyaofule')
                this.data= newVal
            }
        }
    },
    computed:{
        computedHeight(){
            if (typeof this.tableHeight === 'number') {
                return `calc(${this.tableHeight}px - 60px)`;
            } else {
                return `calc(${this.tableHeight} - 60px)`;
            }
        }
    },
    methods: {
        handleSelectionChange (val) {
            console.log(val)
            this.multipleSelection = []
            if (val.length > 0) {
                // 创建一个集合来存储 val 中的项以便快速查找
                const valSet = new Set(val);

                this.data.forEach(item2 => {
                    item2.checked = valSet.has(item2);
                });
                // 清空 multipleSelection.value 数组
                this.multipleSelection.length = 0;

                val.forEach(item => {
                    if (this.data.includes(item)) {
                        this.multipleSelection.push(item[this.exportValue]);
                    }
                });
            } else {
                this.data.forEach(item2 => {
                    item2.checked = false;
                });
            }
            console.log()
            this.$emit('getSelections', this.multipleSelection, val)
        },
        getPagination(value) {
            console.log(value)
            if (value) {
                this.pager.pageSize = value.limit
                this.pager.pageNo = value.page
            }
            if(this.$listeners['pagination']){
                this.$emit('pagination', this.pager)
            }else if(this.$listeners['queryTable']){
                this.$emit('queryTable',value.limit,value.page)
            }
        },
        rowClassName({ row, rowIndex }){
            if(this.isScreen){
                return 'table-row-border'
            }
        }
    }
}
</script>
<style scoped>
.el-table {
    /* overflow: auto; */
}
</style>




// WEBPACK FOOTER //
// src/Hcomponents/Htable/index.vue